// src/EventBus.ts
import { EventEmitter } from 'events';

export const eventBus = new EventEmitter();
